<template>
  <div class="animated fadeIn">
    <b-col sm="12" lg="12">
      <b-card ref="cardRef" class="backClass">
        <div
          slot="header"
          style="display:flex; justify-content: space-between; align-items: center;"
        >
          <HeaderTitle title="Backlog by Location"></HeaderTitle>
          <b-form-input
            style="display:inline-block; width:250px;float:right"
            v-model="searchQuery"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>
        </div>
        <hr />
        <div v-if="loadingData" class="centered_container">
          <LoadingCard></LoadingCard>
        </div>
        <b-row>
          <b-col
            lg="3"
            sm="6"
            :key="location.id"
            v-for="location in filterItems(locations)"
            style="padding: 5px;"
          >
            <a
              class="locationLabels"
              :href="
                '#/base/city/?loc=' +
                  location.id +
                  '&city=' +
                  location.locaton +
                  '&lat=' +
                  location.lat +
                  '&lng=' +
                  location.lng
              "
              >{{ location.locaton }}</a
            >
            <span v-if="location.backlog != 0" style="color:yellow">{{
              location.backlog
            }}</span>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </div>
</template>

<script>
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import LoadingCard from "../../../components/shared/LoadingCard.vue";

export default {
  name: "BacklogByLocation",
  components: { LoadingCard, HeaderTitle },
  props: ["locationData"],
  data() {
    return {
      searchQuery: "",
      loadingData: false,
      locations: []
    };
  },
  methods: {
    fetchLocations() {
      this.loadingData = true;
      this.$http.get("api/arris/profile/alphaLocationsBacklog.php", {}).then(
        res => {
          this.locations = res.data.records;
          this.loadingData = false;
        },
        err => {
          console.log(err);
          this.loadingData = false;
        }
      );
    },
    filterItems: function(locations) {
      return locations.filter(location => {
        let regex = new RegExp("(" + this.searchQuery + ")", "i");
        return location.locaton.match(regex);
      });
    }
  },
  mounted() {
    this.fetchLocations();
  }
};
</script>

<style scoped>
.locationLabels {
  padding: 9px;
}
.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
